import { call, put, fork, takeEvery } from 'redux-saga/effects';
import watchSiteProfileSaga from '../siteProfile/services/siteProfileSaga';
import watchsiteListSaga from '../siteList/services/siteListSaga';
import watchunassignedSiteListSaga from '../unassignedSiteList/services/unassignedSiteListSaga';
import watchsitealiasmanagementSaga from '../sitealiasmanagement/services/siteAliasSaga';
import watchSiteHourlyVolumeShareSaga from '../hourlyVolumeShare/services/hourlyVolumeShareSaga';
 
// Fetch Site List Saga
// function* fetchSiteListSaga(action) {
//     try {
//         const response = yield call(services.getAllSiteList, action.payload);

//         if (response?.success) {
//             const data = {
//                 isCustomView: false, 
//                 fieldName: [], 
//                 fieldValues: response.values || [], 
//                 data: response.values || []
//             };
//             yield put(actions.fetchSiteListSuccess(data));
//         } else {
//             yield put(actions.fetchSiteListFailure('No data found'));
//         }
//     } catch (error) {
//         console.error('SITE List Fetch Error:', error);
//         yield put(actions.fetchSiteListFailure('Failed to fetch SITE list'));
//         // Swal.fire('Error', 'Failed to load SITE List', 'error');
//     }
// }

// Fetch Practice Dropdown Saga
// function* fetchPracticeDropdownSaga() {
//     try {
//         const response = yield call(services.getPracticeDropdownData);

//         if (response?.success) {
//             yield put(actions.fetchPracticeDropdownSuccess(response.values || []));
//         } else {
//             yield put(actions.fetchPracticeDropdownFailure('Failed to fetch practice dropdown'));
//         }
//     } catch (error) {
//         console.error('Practice Dropdown Fetch Error:', error);
//         yield put(actions.fetchPracticeDropdownFailure('Failed to fetch practice dropdown'));
//     }
// }

// Fetch Site Dropdown Saga
// function* fetchSiteDropdownSaga() {
//     try {
//         const response = yield call(services.getSiteDropdownData);

//         if (response?.success) {
//             yield put(actions.fetchSiteDropdownSuccess(response.values || {}));
//         } else {
//             yield put(actions.fetchSiteDropdownFailure('Failed to fetch site dropdown'));
//         }
//     } catch (error) {
//         console.error('Site Dropdown Fetch Error:', error);
//         yield put(actions.fetchSiteDropdownFailure('Failed to fetch site dropdown'));
//     }
// }

// Fetch Sub Practice Dropdown Saga
// function* fetchSubPracticeDropdownSaga() {
//     try {
//         const response = yield call(services.getSubPracticeDropdownData);

//         if (response?.success) {
//             yield put(actions.fetchSubPracticeDropdownSuccess(response || {}));
//         } else {
//             yield put(actions.fetchSubPracticeDropdownFailure('Failed to fetch sub-practice dropdown'));
//         }
//     } catch (error) {
//         console.error('Sub Practice Dropdown Fetch Error:', error);
//         yield put(actions.fetchSubPracticeDropdownFailure('Failed to fetch sub-practice dropdown'));
//     }
// }

// Save Bulk Practice Site Saga
// function* saveBulkPracticeSiteSaga(action) {
//     try {
//         const response = yield call(services.saveBulkPracticeSiteData, action.payload);

//         if (response?.success) {
//             yield put(actions.saveBulkPracticeSiteSuccess(response));
//             // Optionally refresh the site list after successful save
//             // yield put(actions.fetchSiteListRequest({}));
//         } else {
//             yield put(actions.saveBulkPracticeSiteFailure(response?.errorMessage || 'Failed to save bulk practice site mapping'));
//         }
//     } catch (error) {
//         console.error('Save Bulk Practice Site Error:', error);
//         yield put(actions.saveBulkPracticeSiteFailure('Failed to save bulk practice site mapping'));
//     }
// }

// // Fetch Site Profile Saga
// function* fetchSiteProfileSaga(action) {
//     try {
//         const response = yield call(services.getSiteProfileData, action.payload);

//         if (response?.success) {
//             yield put(actions.fetchSiteProfileSuccess(response));
//         } else {
//             yield put(actions.fetchSiteProfileFailure(response?.errorMessage || 'Failed to fetch site profile'));
//         }
//     } catch (error) {
//         console.error('Site Profile Fetch Error:', error);
//         yield put(actions.fetchSiteProfileFailure('Failed to fetch site profile'));
//     }
// }

// // Fetch Site Coverage Hours Saga
// function* fetchSiteCoverageHoursSaga(action) {
//     try {
//         const response = yield call(services.getSiteCoverageHoursData, action.payload);

//         if (response?.success) {
//             yield put(actions.fetchSiteCoverageHoursSuccess(response));
//         } else {
//             yield put(actions.fetchSiteCoverageHoursFailure(response?.errorMessage || 'Failed to fetch site coverage hours'));
//         }
//     } catch (error) {
//         console.error('Site Coverage Hours Fetch Error:', error);
//         yield put(actions.fetchSiteCoverageHoursFailure('Failed to fetch site coverage hours'));
//     }
// }

// // Fetch Site Associated Radiologists Saga
// function* fetchSiteAssociatedRadsSaga(action) {
//     try {
//         const response = yield call(services.getSiteAssociatedRadsData, action.payload);

//         if (response?.success) {
//             yield put(actions.fetchSiteAssociatedRadsSuccess(response.values || {}));
//         } else {
//             yield put(actions.fetchSiteAssociatedRadsFailure('Failed to fetch site associated radiologists'));
//         }
//     } catch (error) {
//         console.error('Site Associated Rads Fetch Error:', error);
//         yield put(actions.fetchSiteAssociatedRadsFailure('Failed to fetch site associated radiologists'));
//     }
// }

// Sagas
function* siteSaga() {
    // yield takeEvery(types.FETCH_SITE_LIST_REQUEST, fetchSiteListSaga);
    // yield takeEvery(types.FETCH_PRACTICE_DROPDOWN_REQUEST, fetchPracticeDropdownSaga);
    // yield takeEvery(types.FETCH_SITE_DROPDOWN_REQUEST, fetchSiteDropdownSaga);
    // yield takeEvery(types.FETCH_SUB_PRACTICE_DROPDOWN_REQUEST, fetchSubPracticeDropdownSaga);
    // yield takeEvery(types.SAVE_BULK_PRACTICE_SITE_REQUEST, saveBulkPracticeSiteSaga);
    //  yield fork(watchsiteListSaga);
    //  yield fork(watchunassignedSiteListSaga);
    
    // yield takeEvery(types.FETCH_SITE_PROFILE_REQUEST, fetchSiteProfileSaga);
    // yield takeEvery(types.FETCH_SITE_COVERAGE_HOURS_REQUEST, fetchSiteCoverageHoursSaga);
    // yield takeEvery(types.FETCH_SITE_ASSOCIATED_RADS_REQUEST, fetchSiteAssociatedRadsSaga);

    yield fork(watchSiteProfileSaga);
    yield fork(watchsiteListSaga);
    yield fork(watchunassignedSiteListSaga);
    yield fork(watchsitealiasmanagementSaga);
    yield fork(watchSiteHourlyVolumeShareSaga);
}

export default siteSaga;
